import { useEffect, useMemo } from 'react'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'store/store'
import { clearMaterialSelected } from 'store/ProductContext'
import { ClientsListInterface } from '../ModalPostOn'
import { URL_CONST } from 'constants/urls'
import { getUser } from 'commons/utils/user'

import {
  setCheckedRecords,
  setDuplicateOrder
} from 'store/SalesOrderContext/salesOrderSlice'
import TopSection from 'container/CreateOrder/components/TopSection'

import * as DraftOV from 'services/draft'
import { TypesValidations } from 'constants/enums'
import { getPostOnBody } from 'container/ManageOrders/utils'
import { usePermissions } from 'commons/customHooks/useAuth'
import { ActionPerm } from 'components/Structures/Header/constants'
import { ACTIONS_SCREENS, SCREENS } from 'commons/utils/permissions'
import { OriginOrder } from 'constants/enums'

interface ConfigOrderProp {
  step: number
  isButtonRescueData?: boolean
  hasOVs?: boolean
}

function ConfigOrder({
  step,
  isButtonRescueData = false,
  hasOVs = false
}: ConfigOrderProp) {
  const { draftBody, duplicateOrder, records } = useSelector((state) => state.salesOrder)
  const { verifyPermission } = usePermissions()
  function shouldDisable(action: ActionPerm) {
    return !verifyPermission(SCREENS.ORDER, action)
  }
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {
    cd_cond_pgto,
    ds_cond_pgto,
    mescotas,
    cd_seto_atvd,
    fl_mto_prep,
    cd_clie,
    nm_clie,
    cd_empr,
    cd_orgn_vend,
    cd_canl_dstb,
    nr_pedi_rasc,
    cd_regi_vend,
    ds_regi_vend,
    cd_escr_vend,
    nr_cpnj_cpf_entr: nr_cnpj_cpf,
    tp_orig
  } = draftBody

  const { orderNumber } = useParams()

  const isRestricted = useMemo(
    () =>
      records.length && records.every((record) => record.cd_stat_pedi_rasc_item === 90),
    [records]
  )

  useEffect(() => {
    dispatch(clearMaterialSelected())
  }, [])

  function paymentLabel() {
    if (!!cd_cond_pgto && !!ds_cond_pgto) {
      return `${cd_cond_pgto} - ${ds_cond_pgto}`
    }
    return undefined
  }

  const handleDeleteDraftOrder = async () => {
    await DraftOV.deleteDraftOV({
      nr_pedi_rasc: draftBody.nr_pedi_rasc,
      dt_alte_antr: draftBody.dt_alte,
      cd_usua_alte: getUser()
    }).then(() => toast.success('O pedido foi excluído com sucesso.'))
  }

  const handlePostOnTopSection = async (array: ClientsListInterface[]) => {
    const body = getPostOnBody(array, draftBody, orderNumber)

    const post = await DraftOV.duplicateDraftOV(body)
    if (post) {
      navigate(URL_CONST.ORDERS)
    }
    dispatch(setCheckedRecords([]))
  }

  const handleDuplicateOrder = async () => {
    await DraftOV.duplicateDraftOV(duplicateOrder).then((response) => {
      if (response) {
        navigate(`${URL_CONST.ORDERS}/${response[0]?.NumeroPedido?.trim()}`)
        toast.success(
          'Pedido duplicado com sucesso. Isso gerou um novo Pedido Rascunho com as configurações selecionadas.'
        )
      } else {
        toast.error('Erro ao duplicar pedido.')
      }
    })
    setDuplicateOrder({ ...duplicateOrder, Clientes: [] })
  }

  return (
    <TopSection
      quotasMonth={mescotas}
      defaultPayment={paymentLabel()}
      isButtonRescueData={isButtonRescueData}
      defaultClient={{
        cd_clie,
        nm_clie,
        cd_empr,
        cd_orgn_vend,
        cd_canl_dstb,
        cd_seto_atvd,
        cd_regi_vend,
        ds_regi_vend,
        nr_cnpj_cpf,
        cd_escr_vend
      }}
      onClickPostOn={handlePostOnTopSection}
      onClickDuplicate={handleDuplicateOrder}
      onClickDelete={handleDeleteDraftOrder}
      orderNumber={nr_pedi_rasc}
      materialTypeMTO={fl_mto_prep === TypesValidations.YES}
      disableClientConfig={!!records.length || shouldDisable(ACTIONS_SCREENS.EDIT)}
      disableOrderConfig={
        step !== 0 || isRestricted || shouldDisable(ACTIONS_SCREENS.EDIT)
      }
      disableToolbar={shouldDisable(ACTIONS_SCREENS.EDIT)}
      disableFields
      step={step}
      hasOvs={hasOVs}
      isEDI={tp_orig === OriginOrder.EDI}
    />
  )
}

export default ConfigOrder
